// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2S8oH","clinicsSelect":"TableHeading_clinicsSelect__2oH_j"};